
































































import InlineEditor from '@ckeditor/ckeditor5-build-inline'
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  data: -> {
    editor: {}
    active: false
    fab: false
    showDeleteConfirm: false
    el: null
    # isSelected: false
  }

  computed: {
    ...mapGetters ['darkTheme', 'selectedNote', 'selectedParent', 'keyboardMode', 'editMode']
    # note: -> this.noteEditor.note
    text: -> this.note.text
    isSelected: ->
      # console.log this.noteKey
      # console.log this.$store.getters.selectedNote
      this.note == this.selectedNote
    # NoteDBkey: -> db.ref('notes').child(this.noteEditor.note['.key'])
    # isSelected: -> this.noteEditor.isSelected
    isSelectedParent: -> this.note == this.selectedParent
    id: -> if this.isSelected then "selectedNote" else ""
  }

  props: {
    note: {type: Object, default: -> {text: ""}}
    noteKey: {default: ""}
  }

  methods: {
    ...mapActions ['setNoteText', 'deleteNote']
    onBlur: (e) ->
      console.log "blurred", e
      if e.relatedTarget?
        #blur from mouse, typically to another part of app
        this.endEdit()
      #blur from keyboard, typlically alt-tab, commit note text anyway, but don't end edit
      this.setNoteText {noteRef: this.noteKey, text: this.editor.getData()}

    onFocus: -> console.log "focused"

    onClick: ->
      this.$store.commit 'setSelectedNoteRef', this.noteKey
      this.$store.commit 'setKeyboardMode', false

    startEdit: ->
      console.log "startEdit"
      this.$store.commit 'setEditMode', true
      initEditor = (returnedEditor) =>
        this.editor = returnedEditor
        # this.editor.setData(this.note.text)
        # this.editor.set('isReadOnly', this.isReadOnly)
        this.editor.element.focus()

        # TODO: remove toolbar
      InlineEditor.create(this.$refs.editorDiv, { toolbar: [] })
      .then(initEditor)
      .catch((error) -> console.error(error))

    endEdit: ->
      console.log "endEdit"
      this.$store.commit 'setEditMode', false
      this.setNoteText {noteRef: this.noteKey, text: this.editor.getData()}
      this.editor.destroy()

  }

  watch: {
    # text: -> this.editor.setData(this.text)
    # noteEditor: -> this.isSelected = this.noteEditor.isSelected
  }

  mounted: ->
    this.el = this.$refs.fab.$el

  destroyed: ->
    if this.editor?
      this.editor.destroy()
        .catch error ->
          console.log error
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TextEditor.vue